import { useState, type ReactNode } from 'react';
import { PageTitleContext } from './page-title-context';

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [title, setPageTitle] = useState('');

  return (
    <PageTitleContext.Provider value={{ title, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
}
